var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiAnguilla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_6581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 16.9125L14.4092 17.1L14.5967 16.9125Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 16.9125L14.2217 17.1L14.4092 16.9125Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9814 17.1L14.7939 17.2875L14.9814 17.1Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7842 17.1L14.5967 17.2875L14.7842 17.1Z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 17.1L14.0342 17.2875L14.2217 17.1Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2627 17.2969L21.0752 17.4844L21.2627 17.2969Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 17.2969L15.1689 17.4844L15.3564 17.2969Z",
    fill: "#1B1B74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 17.2969L14.9814 17.4844L15.1689 17.2969Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9249 17.625C20.9249 22.5563 21.4874 28.0969 17.8312 31.95C17.0812 32.7375 15.6374 34.5469 14.4093 34.4813C13.1249 34.4063 11.4655 32.5031 10.7343 31.575C7.54679 27.375 8.04366 22.3688 7.94054 17.4938C9.37491 18.1406 10.0968 18.3563 11.353 18.3375C12.2905 18.4313 13.7249 17.8219 14.5874 17.4C15.1499 17.775 15.9655 18.2344 17.4374 18.2813C19.1249 18.3563 19.6687 18.0656 20.9249 17.625Z",
    fill: "#CCCC33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 17.2969L13.8379 17.4844L14.0254 17.2969Z",
    fill: "#99994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 17.2969L13.6504 17.4844L13.8379 17.2969Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94043 17.2969L7.75293 17.4844L7.94043 17.2969Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0654 17.4844L20.8779 17.6719L21.0654 17.4844Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8779 17.4844L20.6904 17.6719L20.8779 17.4844Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 17.4844L20.5029 17.6719L20.6904 17.4844Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 17.4844L15.5625 17.6719L15.75 17.4844Z",
    fill: "#1B1B74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 17.4844L15.375 17.6719L15.5625 17.4844Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 17.4844L15.1689 17.6719L15.3564 17.4844Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 17.4844L14.4092 17.6719L14.5967 17.4844Z",
    fill: "#D0D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 17.4844L13.6504 17.6719L13.8379 17.4844Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6504 17.4844L13.4629 17.6719L13.6504 17.4844Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 17.4844L13.2656 17.6719L13.4531 17.4844Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 17.4844L8.3252 17.6719L8.5127 17.4844Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31543 17.4844L8.12793 17.6719L8.31543 17.4844Z",
    fill: "#53527C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12793 17.4844L7.94043 17.6719L8.12793 17.4844Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3066 17.6813L20.1191 17.8688L20.3066 17.6813Z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1191 17.6813L19.9316 17.8688L20.1191 17.6813Z",
    fill: "#53527C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 17.6813L19.7441 17.8688L19.9316 17.6813Z",
    fill: "#1B1B74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 17.6813L15.9375 17.8688L16.125 17.6813Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 17.6813L15.75 17.8688L15.9375 17.6813Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 17.6813L15.5625 17.8688L15.75 17.6813Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7842 17.6813L14.5967 17.8688L14.7842 17.6813Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5408 18.1688C20.6346 20.7563 20.5596 23.6625 20.1658 26.4188C19.7064 27.8719 19.7721 28.6688 19.1064 29.5313L9.82519 29.4563C9.26269 28.5469 8.84082 27.1688 8.79394 26.6156C8.26894 23.8313 8.25957 20.7469 8.24082 17.9906C9.2617 18.5521 10.4278 18.7938 11.5877 18.6844C12.595 18.6239 13.5743 18.3285 14.4471 17.8219C15.3377 18.3469 15.6471 18.5906 17.1096 18.6563C18.2533 18.7125 19.1721 18.8063 20.5408 18.1688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 17.6813L14.2217 17.8688L14.4092 17.6813Z",
    fill: "#F2F1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 17.6813L14.0342 17.8688L14.2217 17.6813Z",
    fill: "#D9D868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 17.6813L13.2656 17.8688L13.4531 17.6813Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 17.6813L13.0781 17.8688L13.2656 17.6813Z",
    fill: "#99994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 17.6813L12.8906 17.8688L13.0781 17.6813Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 17.6813L12.7031 17.8688L12.8906 17.6813Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 17.6813L8.8877 17.8688L9.0752 17.6813Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8877 17.6813L8.7002 17.8688L8.8877 17.6813Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 17.6813L8.5127 17.8688L8.7002 17.6813Z",
    fill: "#99994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51289 17.6813L8.32539 17.8688L8.51289 17.6813ZM19.9316 17.8688L19.7441 18.0563L19.9316 17.8688Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7344 17.8688L19.5469 18.0563L19.7344 17.8688Z",
    fill: "#99994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 17.8688L19.3594 18.0563L19.5469 17.8688Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3594 17.8688L19.1719 18.0563L19.3594 17.8688Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 17.8688L18.9844 18.0563L19.1719 17.8688ZM16.6969 17.8688L16.5094 18.0563L16.6969 17.8688Z",
    fill: "#1B1B74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 17.8688L16.3223 18.0563L16.5098 17.8688Z",
    fill: "#53527C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 17.8688L16.125 18.0563L16.3125 17.8688Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 17.8688L15.9375 18.0563L16.125 17.8688Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 17.8688L14.9814 18.0563L15.1689 17.8688Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9814 17.8688L14.7939 18.0563L14.9814 17.8688Z",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 17.8688L13.8379 18.0563L14.0254 17.8688Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 17.8688L13.6504 18.0563L13.8379 17.8688Z",
    fill: "#D9D868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 17.8688L12.7031 18.0563L12.8906 17.8688Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 17.8688L12.5059 18.0563L12.6934 17.8688Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 17.8688L12.3184 18.0563L12.5059 17.8688Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 17.8688L9.84375 18.0563L10.0312 17.8688Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 17.8688L9.65625 18.0563L9.84375 17.8688Z",
    fill: "#32327B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 17.8688L9.46875 18.0563L9.65625 17.8688Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 17.8688L9.28125 18.0563L9.46875 17.8688Z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14062 17.925L9.01875 17.9907L9.14062 17.925Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 18.0563L20.5029 18.2438L20.6904 18.0563Z",
    fill: "#DDDC7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 18.0563L20.3154 18.2438L20.5029 18.0563Z",
    fill: "#D0D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.041 18.1125L18.9098 18.1782L19.041 18.1125Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7871 18.0563L18.5996 18.2438L18.7871 18.0563Z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 18.0563L18.4121 18.2438L18.5996 18.0563Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 18.0563L18.2158 18.2438L18.4033 18.0563Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 18.0563L18.0283 18.2438L18.2158 18.0563Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 18.0563L16.8848 18.2438L17.0723 18.0563Z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8848 18.0563L16.6973 18.2438L16.8848 18.0563Z",
    fill: "#99994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 18.0563L16.5098 18.2438L16.6973 18.0563Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 18.0563L15.375 18.2438L15.5625 18.0563Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 18.0563L15.1689 18.2438L15.3564 18.0563Z",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6504 18.0563L13.4629 18.2438L13.6504 18.0563Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 18.0563L13.2656 18.2438L13.4531 18.0563Z",
    fill: "#D9D868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3848 18.1125L12.2535 18.1782L12.3754 18.1125H12.3848Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 18.0563L11.9346 18.2438L12.1221 18.0563Z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 18.0563L11.7471 18.2438L11.9346 18.0563Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 18.0563L11.5596 18.2438L11.7471 18.0563Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 18.0563L11.3623 18.2438L11.5498 18.0563Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6689 18.1125L10.5377 18.1782L10.6689 18.1125Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 18.0563L10.2285 18.2438L10.416 18.0563Z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2285 18.0563L10.041 18.2438L10.2285 18.0563Z",
    fill: "#99994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 18.0563L9.84375 18.2438L10.0312 18.0563Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 18.0563L8.3252 18.2438L8.5127 18.0563Z",
    fill: "#DDDC7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31543 18.0563L8.12793 18.2438L8.31543 18.0563Z",
    fill: "#D0D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3066 18.2438L20.1191 18.4313L20.3066 18.2438Z",
    fill: "#F2F1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1191 18.2438L19.9316 18.4313L20.1191 18.2438Z",
    fill: "#E0DEA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 18.2438L19.7441 18.4313L19.9316 18.2438Z",
    fill: "#DDDC7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 18.2438L15.9375 18.4313L16.125 18.2438Z",
    fill: "#D9D868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 18.2438L15.75 18.4313L15.9375 18.2438Z",
    fill: "#E5E3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 18.2438L13.0781 18.4313L13.2656 18.2438Z",
    fill: "#F6F6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 18.2438L12.8906 18.4313L13.0781 18.2438Z",
    fill: "#E1E18C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 18.2438L9.09375 18.4313L9.28125 18.2438Z",
    fill: "#D4D456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 18.2438L8.8877 18.4313L9.0752 18.2438Z",
    fill: "#E1E18C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8877 18.2438L8.7002 18.4313L8.8877 18.2438Z",
    fill: "#EEEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 18.4313L19.3594 18.6188L19.5469 18.4313Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3594 18.4313L19.1719 18.6188L19.3594 18.4313Z",
    fill: "#E0DEA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 18.4313L18.9844 18.6188L19.1719 18.4313Z",
    fill: "#DDDC7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9746 18.4313L18.7871 18.6188L18.9746 18.4313Z",
    fill: "#D0D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 18.4313L16.5098 18.6188L16.6973 18.4313Z",
    fill: "#DDDC7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 18.4313L16.3223 18.6188L16.5098 18.4313Z",
    fill: "#E5E3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 18.4313L16.125 18.6188L16.3125 18.4313Z",
    fill: "#F6F6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 18.4313L12.5059 18.6188L12.6934 18.4313Z",
    fill: "#EEEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 18.4313L12.3184 18.6188L12.5059 18.4313Z",
    fill: "#E1E18C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 18.4313L12.1309 18.6188L12.3184 18.4313Z",
    fill: "#D4D456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 18.4313L9.84375 18.6188L10.0312 18.4313Z",
    fill: "#D9D868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 18.4313L9.65625 18.6188L9.84375 18.4313Z",
    fill: "#E1E18C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 18.4313L9.46875 18.6188L9.65625 18.4313Z",
    fill: "#EEEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 18.4313L9.28125 18.6188L9.46875 18.4313Z",
    fill: "#F6F6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 18.6188L18.4121 18.8063L18.5996 18.6188Z",
    fill: "#F2F1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 18.6188L18.2158 18.8063L18.4033 18.6188Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 18.6188L18.0283 18.8063L18.2158 18.6188Z",
    fill: "#EEEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3252 18.6843L17.2033 18.75L17.3252 18.6843Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 18.6188L16.8848 18.8063L17.0723 18.6188Z",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 18.6188L15.75 18.9938V18.6188H16.125Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 18.6188L11.7471 18.8063L11.9346 18.6188Z",
    fill: "#F2F1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 18.6188L11.5596 18.8063L11.7471 18.6188Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 18.6188L11.3623 18.8063L11.5498 18.6188Z",
    fill: "#E5E3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2309 18.6843L11.109 18.75L11.2402 18.6843H11.2309Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9785 18.6188L10.791 18.8063L10.9785 18.6188Z",
    fill: "#E0DEA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6689 18.6843L10.5377 18.75L10.6689 18.6843Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 18.6188L10.2285 18.8063L10.416 18.6188Z",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 18.8157L16.3223 19.0032L16.5098 18.8157Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 18.8157L16.125 19.0032L16.3125 18.8157Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 19.0032L16.3223 19.1907L16.5098 19.0032Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 19.0032L15.9375 19.1907L16.125 19.0032Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 19.2L16.3223 19.3875L16.5098 19.2Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 19.2L15.9375 19.3875L16.125 19.2Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 19.3875L16.5098 19.575L16.6973 19.3875ZM15.9285 19.3875L15.741 19.575L15.9285 19.3875Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9814 19.3875L14.7939 19.575L14.9814 19.3875Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7842 19.3875L14.5967 19.575L14.7842 19.3875Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 19.3875L13.8379 19.575L14.0254 19.3875Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 19.3875L13.6504 19.575L13.8379 19.3875Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 19.575L16.5098 19.7625L16.6973 19.575Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 19.575L15.75 19.7625L15.9375 19.575Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 19.575L15.375 19.7625L15.5625 19.575Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 19.575L15.1689 19.7625L15.3564 19.575Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 19.575L14.9814 19.7625L15.1689 19.575Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6504 19.575L13.4629 19.7625L13.6504 19.575Z",
    fill: "#FCB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 19.575L13.2656 19.7625L13.4531 19.575Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 19.7719L16.5098 19.9594L16.6973 19.7719Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 19.7719L15.5625 19.9594L15.75 19.7719ZM13.2656 19.7719L13.0781 19.9594L13.2656 19.7719Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 19.7719L12.8906 19.9594L13.0781 19.7719Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 19.9594L20.5029 20.1469L20.6904 19.9594Z",
    fill: "#F6F6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 19.9594L16.5098 20.1469L16.6973 19.9594Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 19.9594L12.7031 20.1469L12.8906 19.9594Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 19.9594L12.5059 20.1469L12.6934 19.9594Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 20.1469L16.5098 20.3344L16.6973 20.1469Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 20.1469L12.1309 20.3344L12.3184 20.1469Z",
    fill: "#FCB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 20.1469L11.9346 20.3344L12.1221 20.1469Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8848 20.3438L16.6973 20.5312L16.8848 20.3438Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 20.3438L16.5098 20.5312L16.6973 20.3438Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3623 20.3438L11.1748 20.5312L11.3623 20.3438Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 20.3438L10.9785 20.5312L11.166 20.3438Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9785 20.3438L10.791 20.5312L10.9785 20.3438Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.791 20.3438L10.416 20.7188L10.791 20.3438Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6035 20.3438L10.416 20.5312L10.6035 20.3438Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8848 20.5312L16.6973 20.7188L16.8848 20.5312Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 20.5312L14.0342 20.7188L14.2217 20.5312Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 20.5312L13.8379 20.7188L14.0254 20.5312ZM13.2754 20.5312L13.0879 20.7188L13.2754 20.5312Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 20.5312L12.8906 20.7188L13.0781 20.5312Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 20.7188L16.8848 20.9062L17.0723 20.7188Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 20.7188L14.4092 20.9062L14.5967 20.7188Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 20.7188L14.2217 20.9062L14.4092 20.7188Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 20.7188L12.7031 20.9062L12.8906 20.7188Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 20.7188L12.5059 20.9062L12.6934 20.7188Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 20.7188L11.3623 20.9062L11.5498 20.7188Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3623 20.7188L11.1748 20.9062L11.3623 20.7188Z",
    fill: "#FCB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 20.7188L10.9785 20.9062L11.166 20.7188Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9785 20.7188L10.791 20.9062L10.9785 20.7188Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 20.9062L16.8848 21.0938L17.0723 20.9062Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7842 20.9062L14.5967 21.0938L14.7842 20.9062Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 20.9062L12.3184 21.0938L12.5059 20.9062Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 20.9062L11.5596 21.0938L11.7471 20.9062Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 21.0938L17.0723 21.2812L17.2598 21.0938Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9814 21.0938L14.7939 21.2812L14.9814 21.0938Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 21.0938L12.1309 21.2812L12.3184 21.0938Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 21.0938L11.5596 21.2812L11.7471 21.0938Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 21.2812L17.0723 21.4688L17.2598 21.2812Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 21.2812L14.9814 21.4688L15.1689 21.2812ZM12.1221 21.2812L11.9346 21.4688L12.1221 21.2812Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 21.2812L11.5596 21.4688L11.7471 21.2812Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 21.4688L20.5029 21.6562L20.6904 21.4688Z",
    fill: "#F6F6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 21.4688L17.0723 21.6562L17.2598 21.4688Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 21.4688L14.9814 21.6562L15.1689 21.4688Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 21.4688L11.9346 21.6562L12.1221 21.4688Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 21.4688L11.3623 21.6562L11.5498 21.4688Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4473 21.675L17.2598 21.8625L17.4473 21.675Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 21.675L15.1689 21.8625L15.3564 21.675Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 21.675L11.7471 21.8625L11.9346 21.675Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 21.675L11.3623 21.8625L11.5498 21.675Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4473 21.8625L17.2598 22.05L17.4473 21.8625Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 21.8625L15.1689 22.05L15.3564 21.8625Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 21.8625L14.2217 22.05L14.4092 21.8625Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 21.8625L14.0342 22.05L14.2217 21.8625Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 21.8625L13.8379 22.05L14.0254 21.8625Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 21.8625L13.6504 22.05L13.8379 21.8625Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 21.8625L11.7471 22.05L11.9346 21.8625Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 21.8625L11.5596 22.05L11.7471 21.8625Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 21.8625L11.3623 22.05L11.5498 21.8625Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4467 22.05L17.6436 22.6125L17.4561 22.05H17.4467Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 22.05L15.375 22.2375L15.5625 22.05Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 22.05L15.1689 22.2375L15.3564 22.05Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 22.05L14.2217 22.2375L14.4092 22.05Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6504 22.05L13.4629 22.2375L13.6504 22.05Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 22.05L13.2656 22.2375L13.4531 22.05Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 22.05L11.5596 22.2375L11.7471 22.05Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 22.05L11.3623 22.2375L11.5498 22.05Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2969 22.1813L11.2406 22.3031L11.2969 22.1813Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 22.2375L14.9814 22.425L15.1689 22.2375Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9814 22.2375L14.7939 22.425L14.9814 22.2375Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7842 22.2375L14.5967 22.425L14.7842 22.2375Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 22.2375L14.4092 22.425L14.5967 22.2375Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 22.2375L14.2217 22.425L14.4092 22.2375Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 22.2375L14.0342 22.425L14.2217 22.2375Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 22.2375L13.0781 22.425L13.2656 22.2375Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 22.2375L12.8906 22.425L13.0781 22.2375Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 22.2375L12.7031 22.425L12.8906 22.2375Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 22.2375L12.5059 22.425L12.6934 22.2375Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3848 22.3031L12.2535 22.3687L12.3754 22.3031H12.3848Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 22.2375L11.9346 22.425L12.1221 22.2375Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 22.2375L11.3623 22.425L11.5498 22.2375Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7344 22.4343L19.5469 22.6218L19.7344 22.4343Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 22.4343L19.3594 22.6218L19.5469 22.4343Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 22.4343L14.4092 22.6218L14.5967 22.4343Z",
    fill: "#FCB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 22.4343L14.0342 22.6218L14.2217 22.4343Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 22.4343L13.8379 22.6218L14.0254 22.4343Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 22.4343L12.3184 22.6218L12.5059 22.4343Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 22.4343L12.5059 22.8093L12.3184 22.4343Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 22.4343L11.7471 22.6218L11.9346 22.4343Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 22.4343L11.5596 22.6218L11.7471 22.4343Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 22.4343L11.3623 22.6218L11.5498 22.4343Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7344 22.6218L19.5469 22.8093L19.7344 22.6218Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 22.6218L19.1719 22.9968L19.5469 22.6218Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3594 22.6218L19.1719 22.8093L19.3594 22.6218ZM17.6438 22.6218L17.4563 22.8093L17.6438 22.6218Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4473 22.6218L17.2598 22.8093L17.4473 22.6218Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 22.6218L15.5625 22.8093L15.75 22.6218Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 22.6218L15.375 22.8093L15.5625 22.6218Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 22.6218L15.1689 22.8093L15.3564 22.6218Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7842 22.6218L14.5967 22.8093L14.7842 22.6218Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 22.6218L14.4092 22.8093L14.5967 22.6218Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 22.6218L13.6504 22.8093L13.8379 22.6218Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 22.6218L12.1309 22.8093L12.3184 22.6218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 22.6218L11.9346 22.8093L12.1221 22.6218Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3623 22.6218L11.1748 22.8093L11.3623 22.6218Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7344 22.8093L19.5469 22.9968L19.7344 22.8093Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 22.8093L18.9844 22.9968L19.1719 22.8093Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 22.8093L18.0283 22.9968L18.2158 22.8093Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 22.8093L17.0723 22.9968L17.2598 22.8093Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9502 22.875L16.8189 22.9406L16.9502 22.875Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 22.8093L15.5625 22.9968L15.75 22.8093Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 22.8093L14.9814 22.9968L15.1689 22.8093Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6504 22.8093L13.4629 22.9968L13.6504 22.8093Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 22.8093L12.1309 22.9968L12.3184 22.8093Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 22.8093L10.9785 22.9968L11.166 22.8093Z",
    fill: "#FCB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9785 22.8093L10.791 22.9968L10.9785 22.8093Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2627 23.0062L21.0752 23.1937L21.2627 23.0062Z",
    fill: "#53527C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 23.0062L19.3594 23.1937L19.5469 23.0062Z",
    fill: "#FCB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 23.0062L18.9844 23.1937L19.1719 23.0062Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 23.0062L18.2158 23.1937L18.4033 23.0062Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 23.0062L17.8408 23.1937L18.0283 23.0062Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8311 23.0062L17.6436 23.1937L17.8311 23.0062Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 23.0062L17.0723 23.1937L17.2598 23.0062Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 23.0062L16.8848 23.1937L17.0723 23.0062Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8848 23.0062L16.6973 23.1937L16.8848 23.0062Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 23.0062L15.75 23.1937L15.9375 23.0062Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 23.0062L13.2656 23.1937L13.4531 23.0062Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9785 23.0062L10.791 23.1937L10.9785 23.0062Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94043 23.0062L7.75293 23.1937L7.94043 23.0062Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 23.1937L20.5029 23.3812L20.6904 23.1937Z",
    fill: "#E5E3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 23.1937L19.3594 23.3812L19.5469 23.1937Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9746 23.1937L18.7871 23.3812L18.9746 23.1937Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 23.1937L18.2158 23.3812L18.4033 23.1937Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 23.1937L17.8408 23.3812L18.0283 23.1937Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 23.1937L17.0723 23.3812L17.2598 23.1937Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 23.1937L15.75 23.3812L15.9375 23.1937ZM13.2656 23.1937L13.0781 23.3812L13.2656 23.1937Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.791 23.1937L10.6035 23.3812L10.791 23.1937Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3594 23.3812L19.1719 23.5687L19.3594 23.3812Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7871 23.3812L18.5996 23.5687L18.7871 23.3812Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 23.3812L18.4121 23.5687L18.5996 23.3812Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 23.3812L18.0283 23.5687L18.2158 23.3812Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 23.3812L17.8408 23.5687L18.0283 23.3812Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 23.3812L16.8848 23.5687L17.0723 23.3812Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 23.3812L15.75 23.5687L15.9375 23.3812Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 23.3812L12.8906 23.5687L13.0781 23.3812Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6035 23.3812L10.416 23.5687L10.6035 23.3812Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3594 23.5781L19.1719 23.7656L19.3594 23.5781Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 23.5781L18.0283 23.7656L18.2158 23.5781Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 23.5781L16.8848 23.7656L17.0723 23.5781Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 23.5781L15.9375 23.7656L16.125 23.5781ZM12.8906 23.5781L12.7031 23.7656L12.8906 23.5781Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 23.5781L10.2285 23.7656L10.416 23.5781Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 23.7656L18.9844 23.9531L19.1719 23.7656Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 23.7656L18.2158 23.9531L18.4033 23.7656Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8848 23.7656L16.6973 23.9531L16.8848 23.7656Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 23.7656L15.9375 23.9531L16.125 23.7656Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 23.7656L12.7031 23.9531L12.8906 23.7656Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 23.7656L10.2285 23.9531L10.416 23.7656Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 23.9625L20.5029 24.15L20.6904 23.9625Z",
    fill: "#D3D079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 23.9625L18.9844 24.15L19.1719 23.9625ZM16.8844 23.9625L16.6969 24.15L16.8844 23.9625Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 23.9625L15.9375 24.15L16.125 23.9625ZM12.8906 23.9625L12.7031 24.15L12.8906 23.9625Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2285 23.9625L10.041 24.15L10.2285 23.9625Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 23.9625L8.3252 24.15L8.5127 23.9625Z",
    fill: "#F2F1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 24.0844L7.80937 24.2062L7.875 24.0844Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6348 24.2719L20.5598 24.4031L20.6254 24.2719H20.6348Z",
    fill: "#D9D868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 24.15L18.9844 24.3375L19.1719 24.15Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 24.15L12.8906 24.3375L13.0781 24.15Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 24.15L12.7031 24.3375L12.8906 24.15Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2285 24.15L10.041 24.3375L10.2285 24.15Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44727 24.2719L8.38165 24.4031L8.44727 24.2719Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 24.3375L18.9844 24.525L19.1719 24.3375Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 24.3375L13.0781 24.525L13.2656 24.3375Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 24.3375L12.8906 24.525L13.0781 24.3375Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 24.3375L12.6934 24.7125L12.5059 24.3375Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 24.3375L12.1309 24.525L12.3184 24.3375Z",
    fill: "#FCB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 24.3375L9.84375 24.525L10.0312 24.3375Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 24.3375L9.65625 24.525L9.84375 24.3375Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94043 24.3375L7.75293 24.525L7.94043 24.3375Z",
    fill: "#53527C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0098 24.6562L20.9441 24.7781L21.0098 24.6562Z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9746 24.525L18.7871 24.7125L18.9746 24.525ZM18.4121 24.525L18.2246 24.7125L18.4121 24.525Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 24.525L16.125 24.7125L16.3125 24.525Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 24.525L13.0781 24.7125L13.2656 24.525Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 24.525L12.3184 24.7125L12.5059 24.525Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 24.525L11.9346 24.7125L12.1221 24.525Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 24.525L9.46875 24.7125L9.65625 24.525Z",
    fill: "#FCB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 24.525L9.09375 24.9L9.46875 24.525Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44727 24.6562L8.38165 24.7781L8.44727 24.6562Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 24.6562L7.80937 24.7781L7.875 24.6562Z",
    fill: "#32327B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9092 24.8438L18.8529 24.975L18.9092 24.8438Z",
    fill: "#FCB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 24.7125L18.0283 24.9L18.2158 24.7125Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 24.7125L16.125 24.9L16.3125 24.7125Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 24.7125L13.0781 24.9L13.2656 24.7125Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 24.7125L12.7031 24.9L12.8906 24.7125Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 24.7125L12.5059 24.9L12.6934 24.7125Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 24.7125L11.9346 24.9L12.1221 24.7125Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 24.7125L9.28125 24.9L9.46875 24.7125Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0654 24.9L20.8779 25.0875L21.0654 24.9Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 24.9L20.3154 25.0875L20.5029 24.9Z",
    fill: "#F6F6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 24.9L18.0283 25.0875L18.2158 24.9Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 24.9L16.5098 25.0875L16.6973 24.9Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 24.9L16.3223 25.0875L16.5098 24.9Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 24.9L16.125 25.0875L16.3125 24.9Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 24.9L12.8906 25.0875L13.0781 24.9Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 24.9L12.7031 25.0875L12.8906 24.9ZM11.9344 24.9L11.7469 25.0875L11.9344 24.9Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 24.9L9.09375 25.0875L9.28125 24.9Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 24.9L8.3252 25.0875L8.5127 24.9Z",
    fill: "#DDDC7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0654 25.0969L20.8779 25.2844L21.0654 25.0969Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 25.0969L20.3154 25.2844L20.5029 25.0969Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9092 25.2188L18.8529 25.35L18.9092 25.2188Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 25.0969L18.0283 25.2844L18.2158 25.0969Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 25.0969L16.125 25.2844L16.3125 25.0969Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 25.0969L15.9375 25.2844L16.125 25.0969Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 25.0969L15.5625 25.2844L15.75 25.0969Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 25.0969L15.375 25.2844L15.5625 25.0969Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 25.0969L12.8906 25.2844L13.0781 25.0969Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 25.0969L12.7031 25.2844L12.8906 25.0969Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 25.0969L11.7471 25.2844L11.9346 25.0969Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 25.0969L11.5596 25.2844L11.7471 25.0969Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 25.0969L8.8877 25.2844L9.0752 25.0969Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 25.0969L8.3252 25.2844L8.5127 25.0969Z",
    fill: "#D9D868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0654 25.2844L20.8779 25.4719L21.0654 25.2844Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 25.2844L20.3154 25.4719L20.5029 25.2844Z",
    fill: "#E5E3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 25.2844L17.8408 25.4719L18.0283 25.2844Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 25.2844L15.9375 25.4719L16.125 25.2844Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 25.2844L15.375 25.4719L15.5625 25.2844Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 25.2844L15.1689 25.4719L15.3564 25.2844Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 25.2844L13.0781 25.4719L13.2656 25.2844Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 25.2844L12.8906 25.4719L13.0781 25.2844Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 25.2844L12.7031 25.4719L12.8906 25.2844Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 25.2844L11.5596 25.4719L11.7471 25.2844ZM10.2189 25.2844L10.0314 25.4719L10.2189 25.2844Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 25.2844L9.84375 25.4719L10.0312 25.2844Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 25.2844L9.65625 25.4719L9.84375 25.2844Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 25.2844L9.46875 25.4719L9.65625 25.2844Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 25.2844L9.28125 25.4719L9.46875 25.2844Z",
    fill: "#FCB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 25.2844L8.8877 25.4719L9.0752 25.2844Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12793 25.2844L7.94043 25.4719L8.12793 25.2844Z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0654 25.4812L20.8779 25.6687L21.0654 25.4812Z",
    fill: "#32327B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8223 25.5938L20.7566 25.7344L20.8129 25.6031L20.8223 25.5938Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 25.4812L20.3154 25.6687L20.5029 25.4812Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9746 25.4812L18.7871 25.6687L18.9746 25.4812Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8311 25.4812L17.6436 25.6687L17.8311 25.4812Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 25.4812L15.75 25.6687L15.9375 25.4812Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 25.4812L15.1689 25.6687L15.3564 25.4812Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6504 25.4812L13.4629 25.6687L13.6504 25.4812Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 25.4812L13.2656 25.6687L13.4531 25.4812Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 25.4812L12.5059 25.6687L12.6934 25.4812Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 25.4812L11.5596 25.6687L11.7471 25.4812Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2285 25.4812L10.041 25.6687L10.2285 25.4812Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 25.4812L9.09375 25.6687L9.28125 25.4812Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 25.4812L8.8877 25.6687L9.0752 25.4812Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12793 25.4812L7.94043 25.6687L8.12793 25.4812Z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 25.6687L20.3154 25.8562L20.5029 25.6687Z",
    fill: "#D9D868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9746 25.6687L18.7871 25.8562L18.9746 25.6687Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6436 25.6687L17.4561 25.8562L17.6436 25.6687ZM15.9279 25.6687L15.7404 25.8562L15.9279 25.6687Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 25.6687L15.1689 25.8562L15.3564 25.6687Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 25.6687L14.2217 25.8562L14.4092 25.6687Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 25.6687L14.0342 25.8562L14.2217 25.6687Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 25.6687L13.8379 25.8562L14.0254 25.6687Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 25.6687L13.6504 25.8562L13.8379 25.6687Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 25.6687L12.5059 25.8562L12.6934 25.6687Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 25.6687L8.5127 25.8562L8.7002 25.6687Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12793 25.6687L7.94043 25.8562L8.12793 25.6687Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8779 25.8562L20.6904 26.0437L20.8779 25.8562Z",
    fill: "#99994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 25.8562L20.3154 26.0437L20.5029 25.8562Z",
    fill: "#D0D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4473 25.8562L17.2598 26.0437L17.4473 25.8562Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 25.8562L17.0723 26.0437L17.2598 25.8562Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 25.8562L15.75 26.0437L15.9375 25.8562Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 25.8562L14.9814 26.0437L15.1689 25.8562Z",
    fill: "#FCB755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9814 25.8562L14.7939 26.0437L14.9814 25.8562Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7842 25.8562L14.5967 26.0437L14.7842 25.8562Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 25.8562L14.4092 26.0437L14.5967 25.8562Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 25.8562L12.8906 26.0437L13.0781 25.8562Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 25.8562L12.7031 26.0437L12.8906 25.8562Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2285 25.8562L10.041 26.0437L10.2285 25.8562Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 25.8562L8.5127 26.0437L8.7002 25.8562Z",
    fill: "#E0DEA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12793 25.8562L7.94043 26.0437L8.12793 25.8562Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8779 26.0531L20.6904 26.2406L20.8779 26.0531Z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3066 26.0531L20.1191 26.2406L20.3066 26.0531Z",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7871 26.0531L18.5996 26.2406L18.7871 26.0531Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 26.0531L16.8848 26.2406L17.0723 26.0531Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8848 26.0531L16.6973 26.2406L16.8848 26.0531Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 26.0531L16.5098 26.2406L16.6973 26.0531Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 26.0531L16.3223 26.2406L16.5098 26.0531Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 26.0531L16.125 26.2406L16.3125 26.0531Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 26.0531L15.9375 26.2406L16.125 26.0531Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 26.0531L15.75 26.2406L15.9375 26.0531Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 26.0531L13.0781 26.2406L13.2656 26.0531Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 26.0531L12.8906 26.2406L13.0781 26.0531Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 26.0531L10.2285 26.2406L10.416 26.0531Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 26.0531L8.5127 26.2406L8.7002 26.0531Z",
    fill: "#E1E18C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25977 26.175L8.19415 26.3063L8.25977 26.175Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12793 26.0531L7.94043 26.2406L8.12793 26.0531Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8779 26.2406L20.6904 26.4281L20.8779 26.2406Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3066 26.2406L20.1191 26.4281L20.3066 26.2406Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7871 26.2406L18.5996 26.4281L18.7871 26.2406Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6504 26.2406L13.4629 26.4281L13.6504 26.2406Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 26.2406L13.2656 26.4281L13.4531 26.2406Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 26.2406L11.5596 26.4281L11.7471 26.2406Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 26.2406L10.2285 26.4281L10.416 26.2406Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 26.2406L8.5127 26.4281L8.7002 26.2406Z",
    fill: "#D4D456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8779 26.4281L20.6904 26.6156L20.8779 26.4281Z",
    fill: "#32327B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3066 26.4281L20.1191 26.6156L20.3066 26.4281Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7871 26.4281L18.5996 26.6156L18.7871 26.4281Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 26.4281L18.4121 26.6156L18.5996 26.4281Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6504 26.4281L13.4629 26.6156L13.6504 26.4281Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 26.4281L11.5596 26.6156L11.7471 26.4281Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 26.4281L10.2285 26.6156L10.416 26.4281Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31543 26.4281L8.12793 26.6156L8.31543 26.4281Z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8779 26.6156L20.6904 26.8031L20.8779 26.6156Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 26.6156L20.5029 26.8031L20.6904 26.6156Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3066 26.6156L20.1191 26.8031L20.3066 26.6156Z",
    fill: "#D9D868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 26.6156L18.4121 26.8031L18.5996 26.6156Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 26.6156L11.7471 26.8031L11.9346 26.6156Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6035 26.6156L10.416 26.8031L10.6035 26.6156Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8877 26.6156L8.7002 26.8031L8.8877 26.6156Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31543 26.6156L8.12793 26.8031L8.31543 26.6156Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 26.8125L20.5029 27L20.6904 26.8125Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 26.8125L18.2158 27L18.4033 26.8125Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 26.8125L14.4092 27L14.5967 26.8125Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 26.8125L14.2217 27L14.4092 26.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0908 26.8688L13.9596 26.9344L14.0908 26.8688Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 26.8125L12.3096 27.1875L12.1221 26.8125Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 26.8125L11.7471 27L11.9346 26.8125Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.791 26.8125L10.9785 27.1875L10.791 26.8125Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8877 26.8125L8.7002 27L8.8877 26.8125Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31543 26.8125L8.12793 27L8.31543 26.8125Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 27L20.5029 27.1875L20.6904 27Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1191 27L19.9316 27.1875L20.1191 27Z",
    fill: "#F2F1D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 27L18.0283 27.1875L18.2158 27Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 27L14.4092 27.1875L14.5967 27Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 27L14.2217 27.1875L14.4092 27Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 27L14.0342 27.1875L14.2217 27Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 27L13.8379 27.1875L14.0254 27Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 27L11.9346 27.1875L12.1221 27Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.791 27L10.6035 27.1875L10.791 27Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8877 27L8.7002 27.1875L8.8877 27Z",
    fill: "#D9D868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 27L8.3252 27.1875L8.5127 27Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31543 27L8.12793 27.1875L8.31543 27Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 27.1875L20.5029 27.375L20.6904 27.1875Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1191 27.1875L19.9316 27.375L20.1191 27.1875Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 27.1875L17.6533 27.5625L18.0283 27.1875Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8311 27.1875L17.6436 27.375L17.8311 27.1875Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 27.1875L14.0342 27.375L14.2217 27.1875Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 27.1875L12.3184 27.375L12.5059 27.1875Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 27.1875L12.1309 27.375L12.3184 27.1875Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 27.1875L10.9785 27.375L11.166 27.1875Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9785 27.1875L10.791 27.375L10.9785 27.1875Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 27.1875L8.8877 27.375L9.0752 27.1875Z",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 27.1875L8.3252 27.375L8.5127 27.1875Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6904 27.375L20.5029 27.5625L20.6904 27.375Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 27.375L20.3154 27.5625L20.5029 27.375Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1191 27.375L19.9316 27.5625L20.1191 27.375Z",
    fill: "#D4D456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 27.375L14.2217 27.5625L14.4092 27.375Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 27.375L12.5059 27.5625L12.6934 27.375Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 27.375L12.3184 27.5625L12.5059 27.375Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3623 27.375L11.1748 27.5625L11.3623 27.375Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 27.375L8.8877 27.5625L9.0752 27.375Z",
    fill: "#EEEDC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 27.375L8.3252 27.5625L8.5127 27.375Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 27.5625L20.3154 27.75L20.5029 27.5625Z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 27.5625L19.7441 27.75L19.9316 27.5625Z",
    fill: "#F6F6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8311 27.5625L17.6436 27.75L17.8311 27.5625Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7842 27.5625L14.5967 27.75L14.7842 27.5625Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.541 27.7031L14.4754 27.825L14.541 27.7031Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 27.5625L12.8906 27.75L13.0781 27.5625Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 27.5625L12.7031 27.75L12.8906 27.5625Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 27.5625L11.5596 27.75L11.7471 27.5625Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 27.5625L11.3623 27.75L11.5498 27.5625Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 27.5625L8.8877 27.75L9.0752 27.5625Z",
    fill: "#D3D079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 27.5625L8.5127 27.75L8.7002 27.5625Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5127 27.5625L8.3252 27.75L8.5127 27.5625Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 27.75L20.3154 27.9375L20.5029 27.75Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 27.75L19.7441 27.9375L19.9316 27.75Z",
    fill: "#E0DEA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 27.75L17.8408 27.9375L18.0283 27.75Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 27.75L15.1689 27.9375L15.3564 27.75Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 27.75L14.9814 27.9375L15.1689 27.75Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9814 27.75L14.7939 27.9375L14.9814 27.75Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 27.75L14.2217 27.9375L14.4092 27.75Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 27.75L11.7471 27.9375L11.9346 27.75Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 27.75L8.5127 27.9375L8.7002 27.75Z",
    fill: "#99994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5029 27.9563L20.3154 28.1438L20.5029 27.9563Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3066 27.9563L20.1191 28.1438L20.3066 27.9563Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 27.9563L19.7441 28.1438L19.9316 27.9563Z",
    fill: "#D4D456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 27.9563L18.0283 28.1438L18.2158 27.9563Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 27.9563L17.8408 28.1438L18.0283 27.9563ZM17.0721 27.9563L16.8846 28.1438L17.0721 27.9563Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8848 27.9563L16.6973 28.1438L16.8848 27.9563Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 27.9563L16.5098 28.1438L16.6973 27.9563Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 27.9563L15.75 28.1438L15.9375 27.9563Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 27.9563L15.5625 28.1438L15.75 27.9563Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 27.9563L15.375 28.1438L15.5625 27.9563Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 27.9563L13.8379 28.1438L14.0254 27.9563Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 27.9563L13.6504 28.1438L13.8379 27.9563Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6504 27.9563L13.4629 28.1438L13.6504 27.9563Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 27.9563L13.2656 28.1438L13.4531 27.9563Z",
    fill: "#FBC477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 27.9563L13.0781 28.1438L13.2656 27.9563Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 27.9563L12.1309 28.1438L12.3184 27.9563Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 27.9563L11.9346 28.1438L12.1221 27.9563Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 27.9563L9.09375 28.1438L9.28125 27.9563Z",
    fill: "#E5E3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 27.9563L8.5127 28.1438L8.7002 27.9563Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3066 28.1438L20.1191 28.3313L20.3066 28.1438Z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7344 28.1438L19.5469 28.3313L19.7344 28.1438Z",
    fill: "#F2F1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 28.1438L18.2158 28.3313L18.4033 28.1438Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4473 28.1438L17.2598 28.3313L17.4473 28.1438Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 28.1438L17.0723 28.3313L17.2598 28.1438Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 28.1438L16.8848 28.3313L17.0723 28.1438Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 28.1438L12.3184 28.3313L12.5059 28.1438Z",
    fill: "#FEA522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 28.1438L12.1309 28.3313L12.3184 28.1438Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 28.1438L9.09375 28.3313L9.28125 28.1438Z",
    fill: "#DDDC7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8877 28.1438L8.7002 28.3313L8.8877 28.1438Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 28.1438L8.5127 28.3313L8.7002 28.1438Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3066 28.3313L20.1191 28.5188L20.3066 28.3313Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0625 28.4625L19.9875 28.5844L20.0625 28.4625Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7344 28.3313L19.5469 28.5188L19.7344 28.3313Z",
    fill: "#D3D079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 28.3313L18.0283 28.5188L18.2158 28.3313Z",
    fill: "#F9D099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 28.3313L17.8408 28.5188L18.0283 28.3313Z",
    fill: "#FCB144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8311 28.3313L17.6436 28.5188L17.8311 28.3313Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6436 28.3313L17.4561 28.5188L17.6436 28.3313Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4473 28.3313L17.2598 28.5188L17.4473 28.3313Z",
    fill: "#FEF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 28.3313L13.0781 28.5188L13.2656 28.3313Z",
    fill: "#F8DCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 28.3313L12.3184 28.5188L12.5059 28.3313Z",
    fill: "#FCF1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 28.3313L9.28125 28.5188L9.46875 28.3313Z",
    fill: "#F6F6E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8877 28.3313L8.7002 28.5188L8.8877 28.3313Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 28.5188L19.3594 28.7063L19.5469 28.5188Z",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 28.5188L13.0781 28.7063L13.2656 28.5188Z",
    fill: "#FBBE66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 28.5188L12.5059 28.7063L12.6934 28.5188Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 28.5188L9.28125 28.7063L9.46875 28.5188Z",
    fill: "#E1E18C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8877 28.5188L8.7002 28.7063L8.8877 28.5188Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1191 28.7156L19.9316 28.9031L20.1191 28.7156Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 28.7156L19.3594 28.9031L19.5469 28.7156Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 28.7156L13.0781 28.9031L13.2656 28.7156Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 28.7156L12.7031 28.9031L12.8906 28.7156Z",
    fill: "#FDAB33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 28.7156L9.46875 28.9031L9.65625 28.7156Z",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 28.7156L8.8877 28.9031L9.0752 28.7156Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8877 28.7156L8.7002 28.9031L8.8877 28.7156Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1191 28.9031L19.9316 29.0906L20.1191 28.9031Z",
    fill: "#1B1B74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 28.9031L19.7441 29.0906L19.9316 28.9031Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 28.9031L19.3594 29.0906L19.5469 28.9031Z",
    fill: "#D0D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 28.9031L13.2656 29.0906L13.4531 28.9031Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 28.9031L12.8906 29.0906L13.0781 28.9031Z",
    fill: "#FE9F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 28.9031L12.7031 29.0906L12.8906 28.9031Z",
    fill: "#FBEAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 28.9031L9.46875 29.0906L9.65625 28.9031Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0752 28.9031L8.8877 29.0906L9.0752 28.9031Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 29.0906L19.7441 29.2781L19.9316 29.0906Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3594 29.0906L19.1719 29.2781L19.3594 29.0906Z",
    fill: "#E5E3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4062 29.2219L13.3313 29.3532L13.4062 29.2219Z",
    fill: "#FACA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 29.0906L12.8906 29.2781L13.0781 29.0906Z",
    fill: "#FAE3C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 29.0906L9.65625 29.2781L9.84375 29.0906Z",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 29.0906L9.09375 29.2781L9.28125 29.0906Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07539 29.0906L8.88789 29.2781L9.07539 29.0906ZM19.9316 29.2781L19.7441 29.4656L19.9316 29.2781Z",
    fill: "#1B1B74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7344 29.2875L19.5469 29.475L19.7344 29.2875Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3594 29.2875L19.1719 29.475L19.3594 29.2875Z",
    fill: "#D0D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 29.2875L18.9844 29.475L19.1719 29.2875Z",
    fill: "#FBFAF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 29.2875L13.0781 29.475L13.2656 29.2875Z",
    fill: "#F9D6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 29.2875L9.65625 29.475L9.84375 29.2875Z",
    fill: "#E5E59D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 29.2875L9.09375 29.475L9.28125 29.2875ZM19.7344 29.475L19.5469 29.6625L19.7344 29.475Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 29.475L18.9844 29.6625L19.1719 29.475Z",
    fill: "#8CBF84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0879 29.475C18.4316 30.8625 16.0879 34.1437 14.3066 34.0875C12.5629 34.0219 10.6035 30.8062 9.84414 29.475H19.0879Z",
    fill: "#00CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 29.475L9.28125 29.6625L9.46875 29.475Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28125 29.475L9.09375 29.6625L9.28125 29.475ZM19.7344 29.6625L19.5469 29.85L19.7344 29.6625Z",
    fill: "#1B1B74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 29.6625L19.3594 29.85L19.5469 29.6625Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 29.6625L18.9844 29.85L19.1719 29.6625Z",
    fill: "#ADB333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9746 29.6625L18.7871 29.85L18.9746 29.6625Z",
    fill: "#1AC5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 29.6625L9.84375 29.85L10.0312 29.6625Z",
    fill: "#68B070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 29.6625L9.28125 29.85L9.46875 29.6625Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 29.8594L19.3594 30.0469L19.5469 29.8594Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9746 29.8594L18.7871 30.0469L18.9746 29.8594Z",
    fill: "#7FB15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2285 29.8594L10.041 30.0469L10.2285 29.8594Z",
    fill: "#27C2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 29.8594L9.84375 30.2344L9.65625 29.8594Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 29.8594L9.28125 30.0469L9.46875 29.8594ZM19.5469 30.0469L19.3594 30.2344L19.5469 30.0469Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3594 30.0469L18.9844 30.4219L19.3594 30.0469Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7871 30.0469L18.5996 30.2344L18.7871 30.0469Z",
    fill: "#34BE9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2285 30.0469L10.041 30.2344L10.2285 30.0469Z",
    fill: "#96B247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65625 30.0469L9.46875 30.2344L9.65625 30.0469Z",
    fill: "#53527C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3594 30.2438L19.1719 30.4313L19.3594 30.2438Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7871 30.2438L18.5996 30.4313L18.7871 30.2438Z",
    fill: "#A2B23D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 30.2438L18.4121 30.4313L18.5996 30.2438Z",
    fill: "#0DC9C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 30.2438L10.2285 30.4313L10.416 30.2438Z",
    fill: "#5BB47C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 30.2438L9.65625 30.4313L9.84375 30.2438Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 30.4313L18.9844 30.6188L19.1719 30.4313Z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 30.4313L18.4121 30.6188L18.5996 30.4313Z",
    fill: "#74B166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6035 30.4313L10.416 30.6188L10.6035 30.4313Z",
    fill: "#27C2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 30.4313L10.2188 30.8063L10.0312 30.4313Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 30.4313L9.65625 30.6188L9.84375 30.4313Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 30.6188L18.9844 30.8063L19.1719 30.6188Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9746 30.6188L18.5996 30.9938L18.9746 30.6188Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 30.6188L18.2158 30.8063L18.4033 30.6188Z",
    fill: "#42BB92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.791 30.6188L10.6035 30.8063L10.791 30.6188Z",
    fill: "#0DC9C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6035 30.6188L10.416 30.8063L10.6035 30.6188Z",
    fill: "#96B247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 30.6188L9.84375 30.8063L10.0312 30.6188Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9746 30.8063L18.7871 30.9938L18.9746 30.8063Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 30.8063L18.2158 30.9938L18.4033 30.8063Z",
    fill: "#ADB333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 30.8063L18.0283 30.9938L18.2158 30.8063Z",
    fill: "#27C2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.791 30.8063L10.6035 30.9938L10.791 30.8063Z",
    fill: "#74B166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2285 30.8063L10.041 30.9938L10.2285 30.8063Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7871 30.9938L18.5996 31.1813L18.7871 30.9938Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 30.9938L18.0283 31.1813L18.2158 30.9938Z",
    fill: "#96B247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 30.9938L17.8408 31.1813L18.0283 30.9938Z",
    fill: "#0DC9C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9785 30.9938L10.791 31.1813L10.9785 30.9938Z",
    fill: "#42BB92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 30.9938L10.791 31.5563L10.416 30.9938Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2285 30.9938L10.041 31.1813L10.2285 30.9938Z",
    fill: "#1B1B74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7871 31.1813L18.5996 31.3688L18.7871 31.1813Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 31.1813L18.4121 31.3688L18.5996 31.1813Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 31.1813L17.8408 31.3688L18.0283 31.1813Z",
    fill: "#7FB15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 31.1813L10.9785 31.3688L11.166 31.1813Z",
    fill: "#34BE9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.416 31.1813L10.2285 31.3688L10.416 31.1813Z",
    fill: "#3A3A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 31.3782L18.4121 31.5657L18.5996 31.3782Z",
    fill: "#1B1B74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 31.3782L16.3127 33.4688L18.4033 31.3782Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8311 31.3782L17.6436 31.5657L17.8311 31.3782Z",
    fill: "#74B166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3623 31.3782L11.1748 31.5657L11.3623 31.3782Z",
    fill: "#27C2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 31.3782L10.9785 31.5657L11.166 31.3782Z",
    fill: "#ADB333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6035 31.3782L10.416 31.5657L10.6035 31.3782Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4033 31.5657L18.2158 31.7532L18.4033 31.5657Z",
    fill: "#32327B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6436 31.5657L17.4561 31.7532L17.6436 31.5657Z",
    fill: "#42BB92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5496 31.5656L12.3184 32.5219L11.5402 31.5563L11.5496 31.5656Z",
    fill: "#0DC9C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3623 31.5657L11.1748 31.7532L11.3623 31.5657Z",
    fill: "#ADB333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.791 31.5657L10.6035 31.7532L10.791 31.5657Z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2158 31.7625L18.0283 31.95L18.2158 31.7625Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4473 31.7625L17.2598 31.95L17.4473 31.7625Z",
    fill: "#42BB92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 31.7625L11.3623 31.95L11.5498 31.7625Z",
    fill: "#96B247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9785 31.7625L11.166 32.1375L10.9785 31.7625Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.791 31.7625L10.6035 31.95L10.791 31.7625Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 31.95L17.8408 32.1375L18.0283 31.95Z",
    fill: "#53527C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 31.95L17.0723 32.1375L17.2598 31.95Z",
    fill: "#42BB92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 31.95L11.5596 32.1375L11.7471 31.95Z",
    fill: "#96B247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9785 31.95L10.791 32.1375L10.9785 31.95Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8311 32.1375L17.6436 32.325L17.8311 32.1375Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 32.1375L16.8848 32.325L17.0723 32.1375Z",
    fill: "#42BB92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 32.1375L11.7471 32.325L11.9346 32.1375Z",
    fill: "#96B247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3623 32.1375L11.7373 32.7L11.3623 32.1375Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 32.1375L10.9785 32.325L11.166 32.1375Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6436 32.3344L17.4561 32.5219L17.6436 32.3344Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8848 32.3344L16.6973 32.5219L16.8848 32.3344Z",
    fill: "#42BB92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 32.3344L11.9346 32.5219L12.1221 32.3344Z",
    fill: "#96B247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3623 32.3344L11.1748 32.5219L11.3623 32.3344Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4473 32.5219L17.2598 32.7094L17.4473 32.5219Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 32.5219L16.5098 32.7094L16.6973 32.5219Z",
    fill: "#68B070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 32.5219L12.3184 32.7094L12.5059 32.5219Z",
    fill: "#27C2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 32.5219L12.1309 32.7094L12.3184 32.5219Z",
    fill: "#ADB333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5498 32.5219L11.3623 32.7094L11.5498 32.5219Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2598 32.7094L17.0723 32.8969L17.2598 32.7094Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 32.7094L16.3223 32.8969L16.5098 32.7094Z",
    fill: "#74B166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 32.7094L12.5059 32.8969L12.6934 32.7094Z",
    fill: "#34BE9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 32.7094L12.3184 32.8969L12.5059 32.7094Z",
    fill: "#ADB333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 32.7094L12.1221 33.0844L11.9346 32.7094Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7471 32.7094L11.5596 32.8969L11.7471 32.7094Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0723 32.8969L16.8848 33.0844L17.0723 32.8969Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 32.8969L16.125 33.0844L16.3125 32.8969Z",
    fill: "#96B247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 32.8969L15.9375 33.0844L16.125 32.8969Z",
    fill: "#0DC9C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 32.8969L12.7031 33.0844L12.8906 32.8969Z",
    fill: "#42BB92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9346 32.8969L11.7471 33.0844L11.9346 32.8969Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8848 33.0938L16.6973 33.2812L16.8848 33.0938Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 33.0938L15.9375 33.2812L16.125 33.0938Z",
    fill: "#A2B23D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 33.0938L15.75 33.2812L15.9375 33.0938Z",
    fill: "#27C2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 33.0938L12.8906 33.2812L13.0781 33.0938Z",
    fill: "#74B166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 33.0938L13.0684 33.8438L12.5059 33.0938Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3184 33.0938L12.1309 33.2812L12.3184 33.0938Z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 33.0938L11.9346 33.2812L12.1221 33.0938Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 33.2812L16.5098 33.4688L16.6973 33.2812Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 33.2812L15.75 33.4688L15.9375 33.2812Z",
    fill: "#ADB333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 33.2812L15.5625 33.4688L15.75 33.2812Z",
    fill: "#42BB92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 33.2812L13.2656 33.4688L13.4531 33.2812Z",
    fill: "#0DC9C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 33.2812L13.0781 33.4688L13.2656 33.2812Z",
    fill: "#96B247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5059 33.2812L12.3184 33.4688L12.5059 33.2812Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 33.4688L16.3223 33.6562L16.5098 33.4688Z",
    fill: "#1B1B74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 33.4688L16.125 33.6562L16.3125 33.4688Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 33.4688L15.375 33.6562L15.5625 33.4688Z",
    fill: "#74B166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 33.4688L15.1689 33.6562L15.3564 33.4688Z",
    fill: "#0DC9C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6504 33.4688L13.4629 33.6562L13.6504 33.4688Z",
    fill: "#34BE9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 33.4688L13.2656 33.6562L13.4531 33.4688Z",
    fill: "#ADB333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6934 33.4688L12.5059 33.6562L12.6934 33.4688Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 33.6562L16.125 33.8438L16.3125 33.6562Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 33.6562L15.9375 33.8438L16.125 33.6562Z",
    fill: "#6E6C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 33.6562L15.5625 34.0312L15.9375 33.6562Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 33.6562L15.1689 33.8438L15.3564 33.6562Z",
    fill: "#96B247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 33.6562L14.9814 33.8438L15.1689 33.6562Z",
    fill: "#27C2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 33.6562L13.6504 33.8438L13.8379 33.6562Z",
    fill: "#68B070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 33.6562L12.7031 33.8438L12.8906 33.6562Z",
    fill: "#32327B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 33.8438L15.75 34.0312L15.9375 33.8438Z",
    fill: "#49497D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9814 33.8438L14.7939 34.0312L14.9814 33.8438Z",
    fill: "#5BB47C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 33.8438L14.0342 34.0312L14.2217 33.8438Z",
    fill: "#27C2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 33.8438L13.8379 34.0312L14.0254 33.8438Z",
    fill: "#96B247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 33.8438L13.6406 34.2188L13.4531 33.8438Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2656 33.8438L13.0781 34.0312L13.2656 33.8438Z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 33.8438L12.8906 34.0312L13.0781 33.8438Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 34.0312L15.5625 34.2188L15.75 34.0312Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 34.0312L15.375 34.2188L15.5625 34.0312Z",
    fill: "#8D8D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7842 34.0312L14.5967 34.2188L14.7842 34.0312Z",
    fill: "#8BB252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 34.0312L14.4092 34.2188L14.5967 34.0312Z",
    fill: "#1AC5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 34.0312L14.2217 34.2188L14.4092 34.0312Z",
    fill: "#5BB47C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 34.0312L13.2656 34.2188L13.4531 34.0312Z",
    fill: "#58587B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 34.2375L15.375 34.425L15.5625 34.2375Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3564 34.2375L15.1689 34.425L15.3564 34.2375Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 34.2375L14.9814 34.425L15.1689 34.2375Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 34.2375L13.6504 34.425L13.8379 34.2375Z",
    fill: "#99994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6502 34.2375L13.4627 34.425L13.6502 34.2375ZM15.1689 34.425L14.9814 34.6125L15.1689 34.425Z",
    fill: "#32327B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9814 34.425L14.7939 34.6125L14.9814 34.425Z",
    fill: "#99994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 34.425L14.0342 34.6125L14.2217 34.425Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 34.425L13.8379 34.6125L14.0254 34.425Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8377 34.425L13.6502 34.6125L13.8377 34.425ZM14.9814 34.6125L14.7939 34.8L14.9814 34.6125Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7842 34.6125L14.5967 34.8L14.7842 34.6125Z",
    fill: "#666677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 34.6125L14.4092 34.8L14.5967 34.6125Z",
    fill: "#A4A43D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 34.6125L14.2217 34.8L14.4092 34.6125Z",
    fill: "#99994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2217 34.6125L14.0342 34.8L14.2217 34.6125Z",
    fill: "#32327B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5967 34.8L14.4092 34.9875L14.5967 34.8Z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4092 34.8L14.2217 34.9875L14.4092 34.8Z",
    fill: "#0E0E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2224 22.05C13.9224 22.7437 12.9849 23.5031 12.7224 23.8781C13.0505 24.2531 13.1161 24.2156 13.0786 24.9093C12.5161 24.3093 12.4974 24.2531 12.1224 24.3375C11.3161 25.1437 11.9817 26.8687 12.6474 27.2437C13.313 27.6468 13.1911 27.2343 14.1942 27.7312C13.7349 28.125 13.2005 27.675 12.7692 27.7968C12.5349 28.0781 12.8817 28.5843 12.7036 29.0718C12.3286 29.0343 12.3661 28.2562 12.2724 27.975C11.9911 26.9437 10.3036 26.2312 10.2192 25.2843C9.86299 25.125 9.51611 25.2375 9.09424 25.4718C9.30049 24.5906 10.0036 24.6 10.2005 24.3281C10.6505 23.6343 11.0536 22.8468 12.0192 22.6406C12.7692 22.4812 12.7036 22.6875 13.1724 22.3593C13.4724 22.1343 14.363 21.7031 14.2224 22.05Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1027 22.8375C12.1027 22.8786 12.119 22.9179 12.148 22.9469C12.1771 22.9759 12.2164 22.9922 12.2574 22.9922C12.2984 22.9922 12.3378 22.9759 12.3668 22.9469C12.3958 22.9179 12.4121 22.8786 12.4121 22.8375C12.4121 22.7965 12.3958 22.7572 12.3668 22.7282C12.3378 22.6992 12.2984 22.6829 12.2574 22.6829C12.2164 22.6829 12.1771 22.6992 12.148 22.7282C12.119 22.7572 12.1027 22.7965 12.1027 22.8375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.575 24.9844C16.1063 24.4031 15.8625 23.2031 15.6563 22.8094C15.1688 22.9219 15.1875 22.9969 14.5781 22.6406C15.375 22.4156 15.4406 22.4344 15.5344 22.0687C15.1969 20.9719 13.3594 20.7562 12.7219 21.1687C12.0469 21.5719 12.4688 21.6562 11.5594 22.2937C11.4281 21.7125 12.075 21.45 12.1688 21.0187C12.0281 20.6719 11.4188 20.7375 11.0813 20.3625C11.2875 20.0344 11.9531 20.4375 12.2438 20.4937C13.275 20.7281 14.7094 19.575 15.5813 19.9312C15.8906 19.6969 15.9563 19.3312 15.9563 18.8344C16.6219 19.4437 16.2844 20.0531 16.4438 20.3625C16.8375 21.0844 17.3531 21.8156 17.0813 22.7625C16.875 23.4937 16.725 23.3437 16.7813 23.9156C16.8469 24.2812 16.8188 25.275 16.575 24.9844Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8753 22.7437C16.791 22.7062 16.6972 22.7343 16.6597 22.8093C16.6467 22.8357 16.6418 22.8653 16.6455 22.8945C16.6493 22.9237 16.6615 22.9511 16.6807 22.9734C16.6999 22.9957 16.7252 23.0118 16.7535 23.0198C16.7818 23.0278 16.8118 23.0274 16.8398 23.0184C16.8678 23.0095 16.8926 22.9926 16.9111 22.9697C16.9295 22.9468 16.9409 22.919 16.9437 22.8897C16.9464 22.8604 16.9406 22.831 16.9268 22.805C16.9129 22.7791 16.8918 22.7578 16.866 22.7437H16.8753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7215 25.3875C13.4715 25.2938 14.6059 25.6969 15.0653 25.7344C15.2059 25.2563 15.1403 25.2188 15.759 24.8907C15.5434 25.6969 15.4965 25.7344 15.759 26.0157C16.8653 26.2875 18.009 24.8251 17.9903 24.0657C17.9903 23.2876 17.6903 23.5969 17.6153 22.4719C18.1778 22.6594 18.0653 23.3625 18.3934 23.6719C18.7684 23.7282 19.0122 23.175 19.5184 23.0813C19.6872 23.4282 19.0028 23.7844 18.8059 24.0094C18.0653 24.7782 18.3184 26.5875 17.559 27.15C17.5965 27.5438 17.8778 27.7875 18.309 28.0313C17.4372 28.3032 17.0903 27.6844 16.7434 27.6563C15.9184 27.6375 15.0278 27.6938 14.3528 26.9719C13.8465 26.4094 14.0434 26.3626 13.5278 26.1282C13.1809 25.9969 12.3465 25.4532 12.7215 25.3782V25.3875Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4847 26.8031C14.502 26.7926 14.517 26.7789 14.5289 26.7626C14.5408 26.7464 14.5494 26.7279 14.5542 26.7083C14.559 26.6887 14.5599 26.6684 14.5568 26.6485C14.5537 26.6285 14.5468 26.6094 14.5363 26.5922C14.5258 26.5749 14.5121 26.5599 14.4958 26.548C14.4795 26.5361 14.4611 26.5275 14.4415 26.5227C14.4219 26.5179 14.4016 26.517 14.3817 26.5201C14.3617 26.5232 14.3426 26.5301 14.3254 26.5406C14.2905 26.5617 14.2656 26.5958 14.2559 26.6354C14.2462 26.675 14.2527 26.7167 14.2738 26.7515C14.2949 26.7864 14.329 26.8113 14.3686 26.821C14.4081 26.8307 14.4499 26.8242 14.4847 26.8031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H30V22.5H60V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4844 0L45.0469 8.48438L33.6562 0H30V2.90625L41.25 11.2969L30 19.6406V22.5H33.75L45 14.1094L56.2031 22.5H60V19.6875L48.7969 11.3438L60 3V0H56.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.125 13.1719L30 20.625V22.5L42.7031 13.1719H40.125ZM48.75 14.1094L48.4688 15.75L57.4688 22.5H60L48.75 14.1094ZM30 0V0.140625L41.6719 8.95312L41.5781 6.89062L32.3438 0H30ZM60 0L48.7969 8.25H51.6094L60 1.96875V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7031 0V22.5H41.2031V0H48.7031ZM60 7.5V15H30V7.5H60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 9.04688V13.5469H30V9.04688H60ZM47.2031 0V22.5H42.7031V0H47.2031Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_6581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAnguilla);
export default __webpack_public_path__ + "static/media/ai Anguilla.f22e99ef41642858e747b3d5accdec61.svg";
export { ForwardRef as ReactComponent };